import { memo, ReactNode, useContext } from "react";
import ReactJoyride from "react-joyride";
import { JoyrideContext } from "./JoyrideContext";
import { JoyrideTooltip } from "./JoyrideTooltip";
import { JoyrideContextProvider } from "./JoyrideContext";

interface Props {
  children: ReactNode;
}

export function JoyrideProvider(props: Props) {
  const { children } = props;
  return (
    <JoyrideContextProvider>
      <JoyrideConsumer>{children}</JoyrideConsumer>
    </JoyrideContextProvider>
  );
}

const JoyrideConsumer = memo((props: Props) => {
  const { children } = props;
  const { steps, callbackFunction, stepIndex, runJoyride } =
    useContext(JoyrideContext);

  return (
    <>
      {runJoyride && (
        <ReactJoyride
          tooltipComponent={JoyrideTooltip}
          disableScrolling
          steps={steps}
          stepIndex={stepIndex}
          run={runJoyride}
          callback={callbackFunction}
          showProgress={true}
          continuous
        />
      )}

      {children}
    </>
  );
});
